import session from "@/api/session";
import { UNLIMITED_PAGE_COUNT } from "@/plugins/filters/constants";

export default {
  fetchAdhocLineItems(p_kind) {
    return session.get(`/pricing/charges-and-credits/?product_kind=${p_kind}&limit=${UNLIMITED_PAGE_COUNT}`);
  },
  fetchAdhocInvoices(acc_id) {
    return session.get(`/accounts/${acc_id}/adhoc-invoices/`);
  },
  downloadInvoice(inv_id) {
    return session.get(`/adhoc-invoices/${inv_id}/pdf/`, { responseType: "blob" });
  },
  createAdhocInvoice(acc_id,data) {
    return session.post(`/accounts/${acc_id}/adhoc-invoices/`,JSON.stringify(data));
  },
  updateDeliveryAddress(p_id,address) {
    return session.patch(`/products/${p_id}/`,JSON.stringify(address));
  },
}
